export default {
    priority: {
        low: 'Low',
        normal: 'Normal',
        high: 'High',
        urgent: 'Urgent',
    },
    priority_integer: {
        4: 'Low',
        3: 'Normal',
        2: 'High',
        1: 'Urgent',
    },
    complexity_integer: {
        4: 'Low',
        3: 'Normal',
        2: 'High',
        1: 'Urgent',
    },
    attendance_type_status: {
        start: 'In Progress',
        finish: 'Done',
        pause: 'Paused',
        idle: 'No action',
    },
    taskier_documents: {
        privacy_policy: 'Privacy policy',
        terms_of_use: 'Terms of use',
    },
    service_chat_status: {
        'in-progress': 'In Progress',
        waiting: 'Waiting',
        unanswered: 'Unanswered',
        finished: 'Closed',
    },
    holiday_scope: {
        municipal: 'Municipal',
        state: 'State',
        federal: 'Federal',
    },
    user_type: {
        admin: 'Administrator',
        agent: 'Agent',
        customer: 'Customer',
        'guest-email': 'Email',
    },
    task_status: {
        open: 'In Progress',
        paused: 'Paused',
        done: 'Done',
    },
    deadline_status: {
        overdue: 'Overdue',
        'on-schedule': 'On Schedule',
        'no-deadline': 'No Deadline',
    },
    article_status: {
        published: 'Published',
        'in-review': 'In Review',
    },
    tenant_subscription_status: {
        active: 'Active',
        overdue: 'Overdue',
        trialing: 'Free Trial',
        canceled: 'Canceled',
    },
    tenant_payment_status: {
        confirmed: 'Confirmed',
        pending: 'Aguardando Pagamento',
        received: 'Received',
        overdue: 'Overdue',
        refunded: 'Refunded',
        refund_requested: 'Refunded Requested',
        chargeback_requested: 'Chargeback Requested',
    },
    connection_status: {
        success: 'Connected',
        failed: 'Connection Problem',
    },
}
